<script>
import {
  userLogin,
  postFzLogin,
  getJsConfig,
  postMultipleEnterPriseLogin,
  // getCepingEntrance
} from "@/constants/api/LOGIN_API";
import {
  PATH_HOME,
  PATH_HOME_YACH,
  PATH_WEEKLY,
  PATH_READ_DAILY,
  PATH_ADD_OKR,
  PATH_FRIENDLY_TIPS,
  PATH_NEW_DETAIL,
  PATH_MYINFO_OKR,
} from "@/constants/URL";
import { LSKeys } from "@/constants/Key";
import NoData from "@/components/common/NoData/index.vue";
import { isYach } from "@/utils/ding";
// import { getUserEntrance } from "@/constants/api/MYORG_API";
import Bus from "@/utils/bus";
import commonData from "@/utils/commonData";
import qs from "qs";
import {ispc} from "@/utils/func";
export default {
  data() {
    return {
      yachEnv: isYach,
      api_list: [
        "biz.chat.chooseConversationByCorpId",
        "biz.contact.departmentsPicker",
        "biz.chat.pickConversation",
        "biz.contact.complexPicker",
        "biz.contact.choose",
        "biz.util.open",
        "biz.group.groupComplexPicker",
        // "util.tool.writeLog"
      ],
      timerFlage: 1,
    };
  },
  components: {
    NoData,
  },
  methods: {
    //登录信息存储
    async saveInfo(res) {
      const expires_ms = res.expires * 1000;
      this.$ls.set(LSKeys.userToken, res.token, expires_ms);
      this.$ls.set(LSKeys.userInfo, res.user);
      // kpi 超管 权限
      // this.$ls.set(LSKeys.kpi_permission, res.user.kpi_permission || "");
      // 360 测评 权限
      // this.$ls.set(
      //   LSKeys.dimension_permission,
      //   res.user.dimension_permission || ""
      // );
      //协同at任务
      this.$atRedPot();
      // 是否为 全职员工
      this.$ls.set(
        LSKeys.is_ftes,
        res.user && res.user.is_ftes ? res.user.is_ftes : ""
      );
      // cookie 灰度用户 15天
      // setCookie("workcode", res.user.workcode, 1296000000);

      document.cookie =
        "workcode=" + res.user &&
        res.user.workcode +
          ";domain=" +
          process.env.VUE_APP_URL.match(/\.(\S*)/)[0];
      // this.getCepingEntrance();
      //我的组织权限
      // return getUserEntrance().then(userres => {
      //   this.$ls.set(LSKeys.orgPermisson, userres.has_access || "");
      // });
    },
    // //360测评权限
    // getCepingEntrance() {
    //   getCepingEntrance().then(res => {
    //     this.$ls.set(LSKeys.cepPermisson, res.access || "");
    //   });
    // },
    //五分钟监听login次数
    loginTimer() {
      const dateTime = new Date(); //获取当前时间戳
      const oldSetTime = this.$ls.get("timerLogins")
        ? this.$ls.get("timerLogins").curtime
        : "";
      const nowGetTime = dateTime.getTime();
      if (!oldSetTime || (nowGetTime - oldSetTime) / 1000 / 60 > 5) {
        this.timerFlage = 1;
        this.$ls.set("timerLogins", {
          curtime: nowGetTime,
          tims: this.timerFlage,
        });
        // } else if ((nowGetTime - oldSetTime) / 1000 / 60 > 5) {
        //   this.timerFlage = 1;
        //   this.$ls.set("timerLogins", {
        //     curtime: nowGetTime,
        //     tims: this.timerFlage
        //   });
      } else {
        this.timerFlage = this.$ls.get("timerLogins").tims + 1;
        this.$ls.set("timerLogins", {
          curtime: oldSetTime,
          tims: this.timerFlage,
        });
      }
    },
    // getRequest() {
    //   const url = "?" + decodeURIComponent(location.href).split("?")[1]; // 获取url中"?"符后的字串
    //   const theRequest = new Object();
    //   if (url.indexOf("?") !== -1) {
    //     const str = url.substr(1);
    //     const strs = str.split("&");
    //     for (const item of strs) {
    //       theRequest[item.split("=")[0]] = item.split("=")[1];
    //     }
    //   }
    //   return theRequest;
    // },
    // 多企业正式登录
    async multipleEnterPriseLogin(params) {
      try {
        const res = await postMultipleEnterPriseLogin(params); // login/code
        Bus.$emit("login", true);
        this.callBack(res);
      } catch (error) {
        console.error("error", error);
      }
    },
    //正式登录
    officialLogin(querys) {
      userLogin({ token: querys.token, times: this.timerFlage })
        .then(async (res) => {
          Bus.$emit("login", true);
          this.callBack(res);
        })
        .catch((res) => {});
    },
    //仿真登录
    async postFzLogin() {
      //039854    018214     // 空 076398   //142506    //121942   032614 000001 115637
      await postFzLogin({
        workcode: this.$route.query.wk || "305869", //xixiaoting
        times: this.timerFlage,
      }).then((res) => {
        Bus.$emit("login", true);
        // this.getCepingEntrance();
        this.callBack(res);
      });
    },

    //登录跳转回调
    async callBack(res) {
      await this.saveInfo(res);
      let querys = qs.parse(window.location.search, {
        ignoreQueryPrefix: true
      });
      if (
        this.$route.query.redirect &&
        (this.$route.query.redirect.split("?")[0] == "/messagelist" ||
          this.$route.query.redirect.split("?")[0] == "/report360")
      ) {
        this.cepingloading = true;
        // alert(this.$route.query.redirect)
        this.$router.push({
          path: this.$route.query.redirect,
        });
      } else if (
        this.$route.query.redirect &&
        this.$route.query.redirect.split("?")[0] == "/frame360"
      ) {
        this.cepingloading = true;
        this.$router.push({
          path:
            this.$route.query.redirect.split("&")[0] +
            "&" +
            decodeURIComponent(
              this.$route.query.redirect.split("&")[1].split("params=")[1]
            ),
        });
        //待办跳转创建
      } else if (this.$route.query.path == "create") {
        if (window.dd.platform === "pc") {
          //有服务端草稿则请求草稿编辑
          if (this.$route.query.draftOkrId) {
            // this.$router.replace({
            //   path: PATH_MYINFO_OKR
            // });
            this.$router.replace({
              path: PATH_ADD_OKR,
              query: {
                id: this.$route.query.draftOkrId,
                draft: "has",
              },
            });
          } else {
            // const getDraftForPending = this.$ls.get(
            //   "creatNew" + this.$ls.get("userInfo").workcode
            // );
            // var existDraft = false;
            // 检测是否有草稿
            // if (getDraftForPending && getDraftForPending.length > 0) {
            //   getDraftForPending.map(item => {
            //     if (item.template_id == this.$route.query.template_id) {
            //       existDraft = true;
            //     }
            //   });
            // }
            //本地无草稿或有对应模版草稿跳创建页
            // if (!getDraftForPending || existDraft) {
            this.$router.replace({
              path: PATH_ADD_OKR,
              query: {
                add: 1,
                template_id: this.$route.query.template_id,
                type: "pending",
              },
            });
            // }
            // else {
            //   //有非该模版草稿则跳列表页
            //   this.$router.replace({
            //     path: PATH_MYINFO_OKR
            //   });
            // }
            // 否则跳创建页
          }
        } else {
          this.$router.replace({ path: PATH_FRIENDLY_TIPS });
        }
        //待办跳转详情
      } else if (this.$route.query.path == "edit") {
        this.$router.replace({
          path: PATH_NEW_DETAIL,
          query: {
            id: this.$route.query.id,
          },
        });
      } else if (querys.search) {
        this.jumpSpecialPath(querys)
      } else {
        //独立应用回跳处理
        if (this.$route.query.common_future == "okr") {
          window.localStorage.setItem("common_future", "okr");
        }
        document.querySelector(".loading-container").style.opacity = "1";
        // eslint-disable-next-line no-console
        // console.log("this.$route.query", this.$route.query);
        if (
          window.localStorage.getItem("common_future") == "weekly" ||
          window.localStorage.getItem("common_future") == "okr" ||
          window.localStorage.getItem("common_future") == "daily" ||
          window.localStorage.getItem("common_future") == "forceRedirect"
        ) {
          if (window.localStorage.getItem("common_future") == "weekly") {
            this.$router.push({ path: PATH_WEEKLY });
          } else if (window.localStorage.getItem("common_future") == "okr") {
            this.$router.replace({ path: PATH_HOME_YACH });
          } else if (window.localStorage.getItem("common_future") == "daily") {
            this.$router.replace({ path: PATH_READ_DAILY });
          } else if (window.localStorage.getItem("common_future") == "forceRedirect") {
            const urlInfo = window.localStorage.getItem("urlInfo");
            const { path, query } = JSON.parse(urlInfo);
            // 跳转回原来的页面
            this.$router.replace({ path: path || PATH_HOME_YACH, query });
          }
          window.localStorage.removeItem("common_future");
          window.localStorage.removeItem("urlInfo");
        } else {
          if (res.user && !res.user.allow_daily && !res.user.allow_weekly) {
            this.$router.replace({ path: PATH_HOME_YACH });
          } else if (
            res.user &&
            res.user.allow_weekly &&
            !res.user.allow_daily
          ) {
            this.$router.replace({ path: PATH_WEEKLY });
          } else if (res.user && res.user.allow_daily) {
            this.$router.replace({ path: PATH_HOME });
          }
        }
      }
      setTimeout(async () => {
        //回调跳转并关闭动画
        document.getElementById("loading-s").style.display = "none";
        this.fetchJsConfig();
      }, 500);
      if (window.bpit_elk_page_start_time) {
        var end_time = new Date().getTime();
        var load_time = end_time - window.bpit_elk_page_start_time;
        commonData(load_time, {
          page: "loading_ani",
        });
      }
    },
    // 多企业获取 JS config
    async fetchJsConfig() {
      const url = window.location.href;
      console.info("isYach", isYach);
      console.info("platform notInYach", window["yach"].platform);
      try {
        const res = await getJsConfig({ url });
        console.log("拿到的 config 是", res);
        if (!isYach) {
          this.$ls.set("ddConfig", res);
          localStorage.setItem("appId", res.appid);
          localStorage.setItem("corpId", res.corp_id);
        } else {
          this.$ls.set("ddConfig", res);
          localStorage.setItem("appId", res.appid);
          localStorage.setItem("corpId", res.corp_id);
        }
        const configRes = res;
        this.ddConfig(configRes); // 里面的 ur
      } catch (e) {
        this.$message(e.message);
        console.error(e);
      }
    },
    //鉴权
    postDingConfig() {
      const url = window.location.href;
      // console.log("geturl", url);
      return postDingConfig({
        url,
      })
        .then((res) => {
          // console.log("postconfigres", res);
          if (isYach) {
            this.$ls.set("ddConfig", res.data);
            localStorage.setItem("appId", res.data.appid);
            localStorage.setItem("corpId", res.data.corp_id);
          } else {
            this.$ls.set("ddConfig", res);
            localStorage.setItem("appId", res.appid);
            localStorage.setItem("corpId", res.corpId);
          }
          const configRes = res;
          // let { agentId, corpId, timeStamp, nonceStr, signature } = configRes;
          this.ddConfig(configRes);
          // return res;
        })
        .catch((err) => {
          this.$message(err.message);
        });
    },
    ddConfig(confres) {
      // console.log("config", window.yach.platform);
      if (window.yach.platform !== "notInYach") {
        const ResConfig = confres;
        // console.log("yach", confres.data);
        window.dd.config({
          agentId: ResConfig.agentId, // 必填，微应用ID
          corpId: ResConfig.corp_id, //必填，企业ID
          timeStamp: ResConfig.time_stamp, // 必填，生成签名的时间戳
          nonceStr: ResConfig.nonce_str, // 必填，生成签名的随机串
          signature: ResConfig.signature, // 必填，签名
          type: 0, //选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
          jsApiList: this.api_list, // 必填，需要使用的jsapi列表，注意：不要带dd。
          onSuccess: (result) => {
            console.log('???result', result);
            Bus.$emit("login", true);
            // this.login = true;
          },
          onFail: (error) => {
            
            ispc ? this.$message.warning("jssdk 鉴权失败") : '';
            window.location.reload();
            // console.log("鉴权失败");
            // window.location.reload ();
          },
        });
      } else {
        window.dd.config({
          agentId: confres.agentId, // 必填，微应用ID
          corpId: confres.corpId, //必填，企业ID
          timeStamp: confres.timeStamp, // 必填，生成签名的时间戳
          nonceStr: confres.nonceStr, // 必填，生成签名的随机串
          signature: confres.signature, // 必填，签名
          type: 0, //选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
          jsApiList: this.api_list, // 必填，需要使用的jsapi列表，注意：不要带dd。
          onSuccess: (result) => {
            Bus.$emit("login", true);
            // this.login = true;
          },
          onFail: (error) => {
            // console.log("鉴权失败");
            window.location.reload();
          },
        });
      }

      // s埋点 muse主页被浏览
      window.sensorsData &&
        window.sensorsData.track("PageView_Muse", {
          pageName: "173", // muse主页
          channel: isYach ? "101" : "102", //判断muse入口来源
        });
    },
    jumpSpecialPath (querys) {
      const {search, dingid, dingname, timer, workid, user_ids, id} = querys
      if (search == 'weeklySearch') {
        location.href = `${location.origin}/weekly?dingid=${dingid}&dingname=${dingname}&timer=${timer}`
      } else if (search == 'okrSearch') {
        location.href = `${location.origin}/myinfo/group?workid=${workid}&scroll=0`
      } else if (search == 'okrScore') {
        location.href = `${location.origin}/score?id=${id}`
      }
    }
  },
};
</script>
